<template>
    <div class="hero__content" :class="{'hero__content--video' : hero_is_video}">
        <div class="hero__text">
            <OfferBoxCashback class="cashback-gift">
                <template #svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="62"><g fill="none" fill-rule="evenodd"><path fill="#FA5528" d="m29.246 54.155-3.77 2.206a4.925 4.925 0 0 1-7.251-3.004l-1.106-4.226a4.925 4.925 0 0 0-3.517-3.516l-4.226-1.107a4.925 4.925 0 0 1-3.003-7.25l2.205-3.771a4.925 4.925 0 0 0 0-4.974l-2.205-3.77a4.925 4.925 0 0 1 3.003-7.251l4.226-1.107a4.925 4.925 0 0 0 3.517-3.516l1.106-4.226a4.925 4.925 0 0 1 7.251-3.004l3.77 2.206a4.925 4.925 0 0 0 4.974 0l3.77-2.206a4.925 4.925 0 0 1 7.251 3.004l1.107 4.226a4.925 4.925 0 0 0 3.517 3.516l4.225 1.107a4.925 4.925 0 0 1 3.004 7.25l-2.206 3.771a4.925 4.925 0 0 0 0 4.974l2.206 3.77a4.925 4.925 0 0 1-3.004 7.251l-4.225 1.107a4.925 4.925 0 0 0-3.517 3.516l-1.107 4.226a4.925 4.925 0 0 1-7.25 3.004l-3.771-2.206a4.925 4.925 0 0 0-4.974 0Z"/><path fill="#FFF" d="M44.41 43.705V30.102H32.907V45h10.224a1.29 1.29 0 0 0 1.277-1.295m-7.227-25.749c.402-.346.92-.454 1.424-.292.503.162.867.552.999 1.07.116.46.018.937-.268 1.31a1.48 1.48 0 0 1-1.183.589h-.001l-4.058-.004 3.087-2.673Zm-11.875 2.677a1.48 1.48 0 0 1-1.184-.588 1.529 1.529 0 0 1-.268-1.31c.132-.52.496-.91.999-1.07a1.46 1.46 0 0 1 1.424.292l3.087 2.672-4.058.004Zm7.6 7.086h12.55a1.29 1.29 0 0 0 1.276-1.295v-2.112a1.29 1.29 0 0 0-1.277-1.295h-6.1a4.002 4.002 0 0 0 1.998-1.384 4.131 4.131 0 0 0 .724-3.543 4.063 4.063 0 0 0-2.702-2.896 3.984 3.984 0 0 0-3.85.792L31.73 19.27l-3.795-3.285a3.984 3.984 0 0 0-3.851-.792 4.064 4.064 0 0 0-2.701 2.896 4.132 4.132 0 0 0 .723 3.544 4.006 4.006 0 0 0 2 1.383H18.01a1.29 1.29 0 0 0-1.277 1.295v2.112a1.29 1.29 0 0 0 1.277 1.295h12.549v-4.5h2.349v4.5ZM30.25 45V30.102H18.747v13.603c0 .712.562 1.295 1.276 1.295H30.25Z"/></g></svg>
                </template>
            </OfferBoxCashback>
            <div class="text">
                <p class="pretitle">Découvrez Testachats et <br> recevez en cadeau cet </p>
                <h1 class="title">Airfryer <span class="accent">GRATUIT</span></h1>
                <p class="pretitle" style="margin-top: 0"><b>comme cadeau de bienvenue</b></p>
            </div>
        </div>
        <div class="hero_img_container">
            <video autoplay muted loop class="hero__deco hero__deco--video" v-if="hero_is_video" >
                <source :src="home_hero_desktop_video" type="video/mp4">
            </video>
            <img v-else class="hero__deco" :src="home_hero_desktop_image"
                 :alt="home_hero_alt">
        </div>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";
import OfferBoxCashback from "../../_commons/fr/newComponents/OfferBoxCashback.vue";

export default {
    name: "HomeHero",
    components: {OfferBoxCashback},
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>

</style>
